export default "__VITE_ASSET__3d1be947__"